import React from "react";
import PropTypes from "prop-types";

import withTranslation from "../../translation";
import InfoBanner from "../index";

import styles from "./index.css";

const ReservationMessage = ({
  bagBannerShown,
  showBagBanner,
  formatTranslation
}) => (
  <InfoBanner
    cosmeticStyles={{
      background: styles.background,
      icon: styles.icon
    }}
    hasShownCallback={bagBannerShown}
    message={formatTranslation("minibag_reservation_message")}
    shouldShow={showBagBanner}
  />
);

ReservationMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  bagBannerShown: PropTypes.func.isRequired,
  showBagBanner: PropTypes.bool.isRequired
};

export default withTranslation(ReservationMessage);
